export default __webpack_public_path__ + "static/media/bg_adorno.4624d0ec.png";